import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=6990fd2e"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6990fd2e')) {
      api.createRecord('6990fd2e', component.options)
    } else {
      api.reload('6990fd2e', component.options)
    }
    module.hot.accept("./Dialog.vue?vue&type=template&id=6990fd2e", function () {
      api.rerender('6990fd2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuItemSelect/Dialog.vue"
export default component.exports